var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-list',{attrs:{"payload":_vm.listPayloadObj,"headers":_vm.headers,"total":_vm.total,"pagination":_vm.pagination},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }